(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sa-collection-page-size"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sa-collection-page-size')) {
    class CollectionPageSize extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.select = this.querySelector('select');
        this.status = this.querySelector('[role="status"]');
        this.retry = this.querySelector('button');
        this.select.addEventListener('change', () => this.save(), { signal: this.controller.signal });
        this.retry.addEventListener('click', () => this.loadAll(), { signal: this.controller.signal });
        queueMicrotask(() => {
          if (!this.isConnected || this.dataset.choice !== 'all') return;
          if (Number(this.dataset.page) > 1) {
            const url = new URL(location.href);
            url.searchParams.delete('page');
            location.replace(url.href);
            return;
          }
          this.loadAll();
        });
      }
      disconnectedCallback() { this.controller.abort(); }
      async save() {
        const choice = this.select.value;
        if (!['15', '30', '60', 'all'].includes(choice)) return;
        this.select.disabled = true;
        this.status.textContent = this.dataset.loading;
        try {
          const response = await fetch(this.dataset.updateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { sa_collection_page_size: choice } }),
            signal: AbortSignal.timeout(10000)
          });
          if (!response.ok) throw new Error('Preference update failed');
          const cart = await response.json();
          if (cart.attributes?.sa_collection_page_size !== choice) throw new Error('Preference not saved');
          const url = new URL(location.href);
          url.searchParams.delete('page');
          url.searchParams.delete('section_id');
          location.assign(url.href);
        } catch {
          this.status.textContent = this.dataset.error;
          this.select.value = this.dataset.choice;
          this.select.disabled = false;
        }
      }
      async loadAll() {
        if (this.loading || !this.dataset.next || !this.isConnected) return;
        this.loading = true;
        this.retry.hidden = true;
        this.status.textContent = this.dataset.loading;
        const container = this.closest('#ProductGridContainer');
        const pagination = container.querySelector('.pagination-wrapper');
        if (pagination) pagination.hidden = true;
        const grid = container.querySelector('#product-grid');
        const seen = new Set([...grid.querySelectorAll('[data-sa-product-id]')].map(item => item.dataset.saProductId));
        try {
          while (this.dataset.next && this.isConnected) {
            const next = new URL(this.dataset.next, location.href);
            if (next.origin !== location.origin) throw new Error('Invalid next page');
            next.searchParams.set('section_id', this.dataset.section);
            const response = await fetch(next.href, { signal: AbortSignal.any([this.controller.signal, AbortSignal.timeout(20000)]) });
            if (!response.ok) throw new Error('Could not load products');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const state = doc.querySelector('sa-collection-page-size');
            const items = doc.querySelectorAll('#product-grid > [data-sa-product-id]');
            if (!state || !items.length || state.dataset.next === this.dataset.next) throw new Error('Incomplete products');
            if (!this.isConnected) return;
            for (const item of items) {
              if (seen.has(item.dataset.saProductId)) continue;
              seen.add(item.dataset.saProductId);
              item.classList.add('scroll-trigger--cancel');
              item.querySelectorAll('img').forEach(image => { image.loading = 'lazy'; });
              grid.appendChild(document.importNode(item, true));
            }
            this.dataset.next = state.dataset.next || '';
          }
          if (this.isConnected) {
            container.querySelector('.pagination-wrapper')?.remove();
            this.status.textContent = '';
          }
        } catch (error) {
          if (this.isConnected) {
            this.status.textContent = this.dataset.error;
            this.retry.hidden = false;
          }
        } finally { this.loading = false; }
      }
    }
    customElements.define('sa-collection-page-size', CollectionPageSize);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sa-minimum-order"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sa-minimum-order')) {
    let checking = false;
    let approvedForm = null;
    const notices = () => [...document.querySelectorAll('sa-minimum-order')];
    const buttons = () => [...document.querySelectorAll('button[name="checkout"], input[name="checkout"]')];
    const update = (source) => {
      const allowed = Number(source.dataset.total) >= 5000;
      notices().forEach((node) => {
        node.dataset.total = source.dataset.total;
        node.textContent = source.textContent;
      });
      buttons().forEach((button) => { button.disabled = checking || !allowed; });
    };
    class MinimumOrder extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected) update(this); });
      }
    }
    customElements.define('sa-minimum-order', MinimumOrder);
    const refresh = async () => {
      const source = notices()[0];
      if (!source) throw new Error('Missing minimum order status');
      const response = await fetch(source.dataset.url, { cache: 'no-store', signal: AbortSignal.timeout(10000) });
      if (!response.ok) throw new Error('Cart check failed');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const state = html.querySelector('sa-minimum-order');
      if (!state || !/^\d+$/.test(state.dataset.total)) throw new Error('Invalid cart check');
      update(state);
      return Number(state.dataset.total) >= 5000;
    };
    const dirtyCart = () => [...document.querySelectorAll('cart-items input[name="updates[]"], cart-drawer-items input[name="updates[]"], [data-sa-cart-quantity-input]')]
      .some((input) => input.value !== input.defaultValue) || !!document.querySelector('.cart__items--disabled, [data-sa-cart-page].is-updating, [data-sa-cart-page].is-syncing-shipping');
    document.addEventListener('submit', async (event) => {
      const form = event.target;
      const submitter = event.submitter;
      if (form === approvedForm) { approvedForm = null; return; }
      if (submitter?.name !== 'checkout') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (checking) return;
      const source = notices()[0];
      if (!source) return;
      if (dirtyCart()) {
        notices().forEach((node) => { node.textContent = source.dataset.checking; });
        return;
      }
      checking = true;
      buttons().forEach((button) => { button.disabled = true; });
      try {
        const allowed = await refresh();
        if (allowed && !dirtyCart() && form.isConnected) {
          checking = false;
          buttons().forEach((button) => { button.disabled = false; });
          approvedForm = form;
          form.requestSubmit(submitter.isConnected ? submitter : buttons().find((button) => button.form === form));
        } else {
          notices().find((node) => node.getClientRects().length)?.focus();
        }
      } catch {
        notices().forEach((node) => { node.textContent = source.dataset.error; });
      } finally {
        checking = false;
        approvedForm = null;
        buttons().forEach((button) => { button.disabled = Number(notices()[0]?.dataset.total || 0) < 5000; });
      }
    }, true);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => { refresh().catch(() => {}); });
    }
    window.addEventListener('pageshow', (event) => { if (event.persisted) refresh().catch(() => {}); });
  }
  } catch(e) { console.error(e); }
})();

})();
